import * as React from 'react';
import { Product } from '~/Api/Product';
import { LtMaxPrice } from '~/Api/User/ProductGroup/LtMaxPrice';

export const ProductProvider: React.FunctionComponent<
	React.PropsWithChildren<{
		ltMaxPrice: LtMaxPrice | null;
		id: string;
		children(product: Product | null): React.ReactNode;
	}>
> = ({ ltMaxPrice, id, children }) => {
	const product = React.useMemo(
		() => ltMaxPrice?.products.find((candidate) => candidate.product.id === id)?.product ?? null,
		[ltMaxPrice, id]
	);
	return <>{children(product)}</>;
};

ProductProvider.displayName = 'LtMaxPrice.ProductProvider';
